import React, { Component } from 'react'
import { Container, Grid, Typography, CardContent, Card, Paper, Icon } from '@material-ui/core';

import StatusBookingPayment from './partials/StatusBookingPayment'

//import PurchaseDetail from './../CheckoutPage/partials/PurchaseDetail'
import ProductDetail from './../CheckoutPage/partials/ProductDetail'
import ProductDetailPasses from './../CheckoutPage/partials/ProductDetailPasses'

export default class Confirmed extends Component {
    constructor(props) {
        super(props)
     
        this.state={
            bookingReference :  this.props.bookingReference
         }
    }

    render() {

        const { content, /* purchaseDetail,  */productDetail, /* messages,  */bookingItems } = this.props

        const idTransaction = this.state.bookingReference

        return (

            <Container className={`container_thankyoupage`} maxWidth="md" >
                <Grid container spacing={2}>
                    <Grid item md={12}>
                        <Card className="card_container confirmed">
                            <CardContent>
                                <Paper className="block-info info-pasajeros mb-2" variant="outlined">
                                    <div className="block-info-container-title MuiPaper-rounded">
                                        <div className="col-icono">
                                            <Icon>info</Icon>
                                        </div>
                                        <div className="col-texto">
                                            <Typography variant="h1" className="title-message">{content.title}</Typography>
                                        </div>
                                    </div>
                                </Paper>
                                <div className="inner-content">
                                    <div className="mensaje-status text-center">
                                        <StatusBookingPayment content={content} idTransaction={idTransaction} />
                                    </div>                                        
                                </div>
                            </CardContent>
                        </Card>

                        { bookingItems[0].type === "pass" ?
                            <ProductDetailPasses
                                bookingItems={bookingItems}
                            />
                            :
                            <ProductDetail
                            bookingItems={bookingItems}
                            productDetail={productDetail}
                            />
                        }
                    </Grid>
                </Grid>
            </Container>
        )
    }
}